export default {
  common: {
    cancel: "Abbrechen",
    apply: "Übernehmen",
    ok: "OK",
    height: "Höhe",
    width: "Breite",
    doubleShelf: "Doppelregal",
    floor: "Boden",
    shelfLoad: "Fachlast",
    layer: "Ebenen",
    depth: "Tiefe",
    shelfHeight: "Fachhöhe:",
    price: "exkl.MwSt. zzgl. Versand",
    addToCart: "In den Warenkorb",
    offerRequest: "Angebot anfordern",
    settingsEdit: "Basiseigenschaften wählen",
    settingsDialogtitle: "Basiseigenschaften",
  },
  fieldOptionsDialog: {
    layer: "Ebenen",
    sidePanelLeft: "Seitenwand Links",
    sidePanelRight: "Seitenwand Rechts",
    securing: "Sicherung",
    bullbarLeft: "Rammschutz Links",
    bullbarRight: "Rammschutz Rechts",
    fieldOptions: "Feldeigenschaften",
  },
  shareEmail: {
    subject: "Link zu meiner Konfiguration",
    body: "Folgenden Link klicken, um meine Konfiguration anzuschauen: ",
  },
  frontView2d: {
    hint: "Hinweis",
    exceededWeight: "Maximale Feldlast überschritten.",
  },
  layerOptionsDialog: {
    layerOptions: "Ebeneneigenschaften",
  },
  loadConfiguration: {
    loadConfiguration: "Konfiguration laden",
    loading: "Lade...",
    existingCodeText:
      "Du hast bereits ein Produkt konfiguriert? Gib bitte hier deinen persönlichen Konfigurationscode ein, um dieses zu laden:",
    configurationCode: "Konfigurationscode",
  },
  pdfDownload: {
    yourConfiguration: "Ihre Konfiguration",
    readyToDownloadText:
      "Ihre Konfiguration wurde erfolgreich gespeichert und Sie können das PDF jetzt herunterladen:",
    downloadNow: "Jetzt herunterladen",
  },
  saveConfiguration: {
    saveConfiguration: "Konfiguration speichern",
    saveSuccessfully: "Konfiguration erfolgreich gespeichert.",
    loadWithCodeText: "Mit folgendem Code können Sie Ihre Konfiguration jederzeit aufrufen:",
  },
  sendEmail: {
    sendConfiguration: "Konfiguration per E-Mail senden",
    saveSuccessfully:
      "Konfiguration erfolgreich gespeichert! Ihre Konfiguration kann nun per E-Mail versendet werden.",
    softwareNote: "Der Versand erfolgt über Ihre vorhandene E-Mail Software.",
    sendEmail: "Email senden ",
  },
  settingsArtus: {
    distancePieces: "Distanzstücke",
    noFloor: "ohne Boden",
    replaceAllBottoms: "Die Auswahl ersetzt alle Böden in der Konfiguration.",
    palletBays: "Palettenstellplätze: {{palletSum}}",
  },
  settingsBertWarehouse: {
    color: "Farbe",
    usableFromBothSides: "Beidseitig nutzbar",
    frameHeight2000Information:
      "Wähle 6 Fachböden und eine Tiefe von 300 mm oder 600 mm, um das Regal für Ordner zu optimieren",
    frameHeight2325Information:
      "Wähle 7 Fachböden und eine Tiefe von 300 mm oder 600 mm, um das Regal für Ordner zu optimieren",
  },
  settingsBertArchive: {
    frameHeight2075Information:
      "Wähle 5 Fachböden und eine Tiefe von 300 mm oder 600 mm, um das Regal für Ordner zu optimieren",
    frameHeight2500Information:
      "Wähle 6 Fachböden und eine Tiefe von 300 mm oder 600 mm, um das Regal für Ordner zu optimieren",
  },
  visualization2d: {
    topView: "Draufsicht",
    frontView: "Frontansicht",
  },
  header: {
    load: "Konfiguration laden",
    save: "Konfiguration speichern",
    sendEmail: "Konfiguration teilen",
    saveAsPdf: "PDF speichern",
  },
  receiveOfferForm: {
    label: "Angebot anfordern",
    data: "Kontaktdaten",
    email: "E-Mail",
    name: "Name",
    company: "Firma",
    phonenumber: "Telefonnummer",
    zip: "PLZ",
    city: "Stadt",
    street: "Straße",
    country: "Land",
    annotation: "Anmerkung",
    errors: {
      required: "Darf nicht leer sein",
      invalidEmail: "E-mail ist nicht korrekt",
    },
    checkInputsInForm: "Bitte Eingaben im Formular prüfen",
    sentOk: "Anfrage wurde erfolgreich versandt.",
    sentError: "Fehler beim Senden der Anfrage.",
    sendButton: "Angebot anfordern",
  },
};
